import { useEffect, useState } from 'react';

/**
 * CountUp: anima de 0 hasta `to` al montar (con 300ms de delay).
 * NO depende de IntersectionObserver ni de getBoundingClientRect, que fallan
 * cuando el contenido va envuelto en wrappers `display:contents` o queda fuera
 * del viewport en mobile. Tampoco usa un guard de "started" que pueda quedar
 * bloqueado tras un cleanup (StrictMode / remount). Esto garantiza que el
 * número NUNCA quede en 0. Respeta prefers-reduced-motion.
 */
export const CountUp = ({ to, duration = 1800, suffix = '', prefix = '', className = '' }) => {
  const [val, setVal] = useState(0);

  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      setVal(to);
      return;
    }

    let raf;
    let start;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.floor(eased * to));
      if (p < 1) raf = requestAnimationFrame(step);
      else setVal(to); // valor final exacto
    };

    const t = setTimeout(() => { raf = requestAnimationFrame(step); }, 300);

    return () => {
      clearTimeout(t);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [to, duration]);

  return (
    <span className={className}>
      {prefix}{val.toLocaleString()}{suffix}
    </span>
  );
};

export default CountUp;
